import type {
  Distance,
  Percentage,
  Point,
  SpatialRectangle,
} from "@pdfking/math"
import type { PrintLayer } from "../print/PrintLayer"
import type { BasePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_media
export type PlotMedia = {
  crop_position: SpatialRectangle<Distance>
  enum: PlotFunction.PLOT_MEDIA
  media_position: SpatialRectangle<Distance>
  page: string
  print_layer: PrintLayer
  scale: Point<Percentage>
} & BasePlotObject
